<h2 mat-dialog-title style="text-align: center">Confirm Edit</h2>
<mat-form-field style="margin-left: 20px; width: 260px">
    <mat-label>Add reason for edit</mat-label>
    <textarea matInput rows="3" [(ngModel)]="editReason"></textarea>
</mat-form-field>
<mat-dialog-actions style="justify-content: space-between" class="p-2">
    <button mat-raised-button color="warn" style="width: 100px" (click)="onCancel()" cdkFocusInitial>
        {{ "GENERAL.cancel" | translate }}
    </button>
    <button mat-raised-button color="primary" style="width: 100px" (click)="onConfirm()">Confirm</button>
</mat-dialog-actions>
